import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { customerMsalInstance } from "./auth/msalConfig";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MsalProvider instance={customerMsalInstance}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { borderRadius: "8px", background: "#0f172a", color: "#fff" },
          }}
        />
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>,
);
